/**
 * Size Guide Component
 * Functionality for a scrollable table with controls & active states
 */
class SizeGuideComponent extends HTMLElement {
  constructor() {
    super();

    this.sizeGuideMeasurementsWrapper = this.querySelector('.size-guide__measurements');

    // Store references for each table-controls pair
    this.tableSections = [];

    // Find all control groups and their matching containers
    const controlGroups = this.querySelectorAll('[data-controls-for]');
    controlGroups.forEach((controlGroup) => {
      const targetId = controlGroup.dataset.controlsFor;
      const container = this.querySelector(`[data-table-container="${targetId}"]`);

      if (container) {
        const section = {
          id: targetId,
          container,
          controlGroup,
          prevButton: controlGroup.querySelector('[data-table-control="prev"]'),
          nextButton: controlGroup.querySelector('[data-table-control="next"]'),
          controls: controlGroup.querySelectorAll('[data-table-control]'),
          canScrollLeft: false,
          canScrollRight: false,
        };
        this.tableSections.push(section);
      }
    });

    //? Tabs
    this.tabControls = this.querySelectorAll('[data-size-guide-tab-control]');
    this.panels = this.querySelectorAll('[data-size-guide-panel-id]');

    if (this.tableSections.length === 0) return;

    this.setupEventListeners();
    this.tableSections.forEach((section) => this.updateScrollState(section));
    this.updateActiveTable();
  }

  setupEventListeners() {
    this.tableSections.forEach((section) => {
      if (section.prevButton) {
        section.prevButton.addEventListener('click', () => this.scrollLeft(section));
      }
      if (section.nextButton) {
        section.nextButton.addEventListener('click', () => this.scrollRight(section));
      }
      section.container.addEventListener('scroll', () => this.updateScrollState(section));
    });

    if (this.tabControls) {
      this.tabControls.forEach((tabControl) => {
        tabControl.addEventListener('click', this.updateActiveTable.bind(this));
      });
    }

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.tableSections.forEach((section) => this.updateScrollState(section));
  }

  updateActiveTable(e) {
    if (!e || !e?.target) return;
    const selectedTab = e.target.dataset.sizeGuideTabControl;

    this.panels.forEach((panel) => {
      const match = panel.dataset.sizeGuidePanelId === selectedTab;
      panel.dataset.active = match;
    });

    this.tabControls.forEach((tabControl) => {
      tabControl.dataset.active = tabControl.dataset.sizeGuideTabControl === selectedTab;
    });

    // Update scroll state for the measurements section after tab change
    const measurementsSection = this.tableSections.find((s) => s.id === 'measurements');
    if (measurementsSection) {
      this.updateScrollState(measurementsSection);
    }
  }

  updateScrollState(section) {
    const { scrollLeft, scrollWidth, clientWidth } = section.container;
    section.canScrollLeft = scrollLeft > 0;
    section.canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;

    section.prevButton.disabled = !section.canScrollLeft;
    section.nextButton.disabled = !section.canScrollRight;

    if (!section.canScrollLeft && !section.canScrollRight) {
      section.controlGroup.classList.add('hidden');
      section.controls.forEach((control) => control.classList.add('hidden'));
      section.container.classList.add('no-scroll');
      this.sizeGuideMeasurementsWrapper.classList.remove('controls-visible');
    } else {
      section.controlGroup.classList.remove('hidden');
      section.controls.forEach((control) => control.classList.remove('hidden'));
      section.container.classList.remove('no-scroll');
      this.sizeGuideMeasurementsWrapper.classList.add('controls-visible');
    }
  }

  scrollLeft(section) {
    if (section.canScrollLeft) {
      section.container.scrollBy({ left: -200, behavior: 'smooth' });
    }
  }

  scrollRight(section) {
    if (section.canScrollRight) {
      section.container.scrollBy({ left: 200, behavior: 'smooth' });
    }
  }
}

customElements.define('size-guide-component', SizeGuideComponent);
